// extracted by mini-css-extract-plugin
module.exports = {"bonusItem":"StatementInvite_bonusItem_tuXUi"};